"use strict";

import { NmsToastrService } from "@nms-ng2/app/shared/components/elements/nms-toastr/nms-toastr.service";

/**
* @ngdoc controller
* @name nms.management.ManageUsersController
* @description Gerencia os usuários da aplicação.
*/
var app = angular.module("nms.management");

app.controller("ManageUsersController", ["$rootScope", "$scope", "$translate", "NgTableParams", "TABLE_PROPERTIES",
    "TableFilterService", "UserPreferencesService", "ManageUsersService", "ManageUsersActionsService",
    "ManageGroupsActionsService", "ManageGroupsService", "NmsToastrService",
    function($rootScope, $scope, $translate, NgTableParams, TABLE_PROPERTIES, TableFilterService, UserPreferencesService,
        ManageUsersService, ManageUsersActionsService, ManageGroupsActionsService, ManageGroupsService,
        nmsToastrService: NmsToastrService) {
        var availableFilterPropertiesKeys = ["globalFilter"];
        $scope.TAB_FEATURES_INDEX = 1;
        $scope.individualPermissionsLabel = $translate.instant("management.users.permissions.individual");
        $scope.searchTooltip = $translate.instant("tooltips.search.searchToolTip");
        $scope.globalFilter
            = UserPreferencesService.loadPreferences({}, "ManageUserGlobalFilter", availableFilterPropertiesKeys).globalFilter;
        $scope.columns = [
            {field: "username"},
            {field: "administrator", filter: null, width: "125"},
            {field: "groupName"},
            {field: "name"},
            {field: "phone"},
            {field: "email"}
        ];

        $scope.tableParams = new NgTableParams(
            {
                page: 1,
                count: TABLE_PROPERTIES.DEFAULT_PAGE_SIZE,
                sorting: {username: "asc"}
            },
            {
                dataset: [],
                filterOptions: {filterFn: TableFilterService.getFilter($scope.columns)}
            }
        );

        $scope.selection = {
            id: "users-list",
            checked: [],
            table: $scope.tableParams
        };

        $scope.tableModel = {
            options: {
                translatePrefix: "management.users.tableColumn"
            },
            columns: $scope.columns,
            selection: $scope.selection,
            tableParams: $scope.tableParams
        };

        $scope.applyGlobalFilter = function() {
            angular.extend($scope.tableParams.filter(), {$: $scope.globalFilter});
        };

        $scope.openAddUserModal = function() {
            var callback = function(user) {
                $scope.tableParams.settings().dataset.push(user);
                $scope.tableParams.reload();
            };

            ManageUsersActionsService.openAddUserModal($scope.tableParams.data, callback);
        };

        /*
        * Abre a modal para edição de usuário.
        * O Parâmetro username é opcional. Ele é usado quando o método é chamado a partir de um click no nome de usuário da
        * tabela. Quando disparado através do link remover na parte superior da tabela, a lógica levará em conta os elementos
        * contidos em $scope.selection.checked.
        * tabIndex: Utilizado pela Login (Dmview - Desktop) em:
        * Edit User -> Edit Permission -> Web Features -> Web Graphical Interface.
        */
        $scope.openEditUserModal = function(username, tabIndex) {
            var callback = function(user) {
                var editedUserIndex = _.findIndex($scope.tableParams.settings().dataset, function(userInTable) {
                    return userInTable.username === user.username;
                });

                if (editedUserIndex !== -1) {
                    $scope.tableParams.settings().dataset[editedUserIndex] = user;
                    $scope.tableParams.reload();
                }
            };

            if (username) {
                ManageUsersActionsService.openEditUserModal(username, callback, tabIndex);
            } else {
                ManageUsersActionsService.verifyAndOpenEditUserModal($scope.selection.checked, callback, tabIndex);
            }
        };

        $scope.tryRemoveUsers = function() {
            var callback = function(usernames) {
                const message = $translate.instant("userList.tableActions.remove.users.success");
                nmsToastrService.success(message);
                _.remove($scope.tableParams.settings().dataset, function(userInTable) {
                    return _.contains(usernames, userInTable.username);
                });
                $scope.tableParams.reload();
            };

            ManageUsersActionsService.tryRemoveUsers($scope.selection.checked, callback);
        };

        $scope.openEditGroupModal = function(groupName) {
            var callback = function(group) {
                init();
            };
            ManageGroupsActionsService.openEditGroupModal($scope.groups, groupName, callback);
        };

        $scope.$on("$destroy", function() {
            var globalFilter: any = {globalFilter: $scope.globalFilter};
            UserPreferencesService.savePreferences(globalFilter, "ManageUserGlobalFilter", availableFilterPropertiesKeys);
        });

        var init = function() {
            ManageUsersService.getAll().then(function(users) {
                $scope.tableParams.settings({dataset: users});
            });
            ManageGroupsService.getGroupNames().then(function(groupNames) {
                $scope.groups = groupNames;
            });
        };

        $scope.openEditModalWithParams = function(username) {
           $scope.openEditUserModal(username, $scope.TAB_FEATURES_INDEX);
        };

        /**
         * Ao editar as permissões do usuário via DmView-Desktop, uma modal com a
         * propriedade 'Set Permissions' será visualizada. Ao clicar na aba
         * 'Web Features' e em seguida no link 'Web graphical interface' o sistema
         * irá redirecionar para a página de usuários do DmView Maestro com a aba
         * referente ao usuário aberta na aba de features.
         * Exemplo do formato dos parâmetros na URL:
         * showEdit=true&username=username.
         */
        const verifyParametersInUrl = function() {
            const queryParams = $rootScope?.queryParams;

            if (queryParams) {
                const hasShowEditTrue = queryParams.indexOf("showEdit=true") !== -1;
                const hasUsername = queryParams.indexOf("username") !== -1;

                if (hasShowEditTrue && hasUsername) {
                    const regex = new RegExp(/(?<=username=).*/);
                    const username = regex.exec($rootScope.queryParams)[0];
                    $scope.openEditModalWithParams(username);
                }
            }
        }

        verifyParametersInUrl();
        init();
    }
]);
